import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface MakeupOccurrenceCapacity {
  enrollmentId: string;
  date: string;
  maxSize: number;
  enrolledCount: number;
  pendingSlots: number;
  activeMakeupCount: number;
  occupancy: number;
  remainingSeats: number | null;
  isFull: boolean;
}

export const getMakeupOccurrenceCapacityAPI = async (params: {
  enrollmentId: string;
  date: string;
}) => {
  const response = await baseAPI.get<MakeupOccurrenceCapacity>(
    '/makeup/capacity',
    { params },
  );
  return response.data;
};

export const useGetMakeupOccurrenceCapacity = (
  params: {
    enrollmentId: string;
    date: string;
  },
  enabled = true,
) => {
  return useQuery({
    queryKey: [KEYS.MAKEUP_OCCURRENCE_CAPACITY, params.enrollmentId, params.date],
    queryFn: () => getMakeupOccurrenceCapacityAPI(params),
    enabled: enabled && !!params.enrollmentId && !!params.date,
  });
};
